module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iG1TW"))).then(() => parcelRequire('hEqeo'));